export default "__VITE_ASSET__Df9mgrA3__"